<template>
    <div class="footer">
      <div class="container">
        <div class="nav-list">
          <ul>
            <li><router-link to="/join/statement">{{$t("footer.nav.item1")}}</router-link></li>
            <li><router-link to="/join/legal">{{$t("footer.nav.item2")}}</router-link></li>
            <li class="last"><router-link to="/contact">{{$t("footer.nav.item3")}}</router-link></li>
          </ul>
        </div>
        <div class="contact">
          <ul>
            <li>{{$t("footer.name")}}</li>
            <li>{{$t("footer.subName")}}</li>
            <li>{{$t("footer.address")}}</li>
            <li>{{$t("footer.phone")}}</li>
          </ul>
        </div>
        <div class="copy">
          <ul>
            <li>{{$t("footer.copyright")}}</li>
            <li>{{$t("footer.copy")}}</li>
            <li><a target="_blank" href="https://beian.miit.gov.cn/">{{$t("footer.licence")}}</a></li>
          </ul>
        </div>
      </div>
      <div class="toTop" @click="toTop(step)" title="返回顶部">
        <i class="iconfont icon-top"></i>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    step: {
      type: Number,
      default: 50
    }
  },
  data () {
    return {
      isActive: false
    }
  },
  methods: {
    toTop (i) {
      document.documentElement.scrollTop -= i
      if (document.documentElement.scrollTop > 0) {
        var c = setTimeout(() => this.toTop(i), 16)
      } else {
        clearTimeout(c)
      }
    }
  },
  mounted () {
  },
  created () {
    var vm = this
    window.onscroll = function () {
      if (document.documentElement.scrollTop > 60) {
        vm.isActive = true
      } else {
        vm.isActive = false
      }
    }
  }
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  .footer
    padding-top 100px
    background #FFF
    color #FFF
    font-family "Source Han Sans CN Normal"
    .container
      padding 0
      background #2A2B2D
      ul
        flexCenter()
      .nav-list
        font-size 20px
        line-height 45px
        padding-top 30px
        li
          margin 0 28px
          position relative
          a
            color #FFF
        li:after
          position absolute
          top 30%
          right -30px
          content ''
          width 2px
          height 20px
          background #FFF
        .last:after
          display none
      .contact
        flexCenter()
        font-size 15px
        padding-bottom 15px
        position relative
        li
          margin 0 10px
          letter-spacing 1px
          line-height 40px
          opacity 0.3
      .contact:after
        position absolute
        bottom 0
        left 0
        content ''
        width 100%
        height 1px
        background #FFF
        opacity 0.1
      .copy
        flexCenter()
        opacity 0.3
        font-size 12px
        line-height 25px
        padding 20px 0 15px
        a
          color #FFF
        li
          margin-right 20px
    .toTop
      flexCenter()
      position fixed
      bottom 50px
      right 30px
      width 50px
      height 50px
      font-size 40px
      text-align center
      background $navBgHoverColor
      border-radius 5px
      cursor pointer
    .toTop:hover
      background $navBgColor
</style>



// WEBPACK FOOTER //
// src/common/footer/Footer.vue